import { useState } from 'react';

import { PdfThumbImageProps, ThumbImageLayoutMode } from './index.types';
import * as Styled from './index.styles';

const getLayoutMode = ({
  fill,
  width,
  height,
}: Pick<
  PdfThumbImageProps,
  'fill' | 'width' | 'height'
>): ThumbImageLayoutMode => {
  if (fill) {
    return 'fill';
  }

  if (typeof width !== 'undefined' || typeof height !== 'undefined') {
    return 'fixed';
  }

  return 'fluid';
};

const PdfThumbImage = ({
  thumb,
  alt,
  fill,
  width,
  height,
  objectFit = 'contain',
  className,
}: PdfThumbImageProps) => {
  const [isSourceFailed, setIsSourceFailed] = useState(false);

  return (
    <picture>
      {!isSourceFailed && <source type="image/webp" srcSet={thumb.webpUrl} />}
      <Styled.ThumbImage
        className={className}
        src={thumb.fallbackUrl}
        alt={alt}
        width={width}
        height={height}
        layoutMode={getLayoutMode({ fill, width, height })}
        imageObjectFit={objectFit}
        loading="lazy"
        decoding="async"
        draggable={false}
        onError={() => setIsSourceFailed(true)}
      />
    </picture>
  );
};

export default PdfThumbImage;
